const dummy_t = (translationKey) => translationKey;

export default [
  {
    path: '/how-to',
    translationKey: dummy_t('footer.serviceAccess'),
  },
  {
    path: '/terms-of-service',
    translationKey: dummy_t('footer.tos'),
  },
  {
    path: '/privacy-policy',
    translationKey: dummy_t('footer.privacyPolicy'),
  },
  {
    externalPath: {
      'en-US': 'https://shestrong.zendesk.com/hc/en-us',
      'sv-SE': 'https://shestrongse.zendesk.com/hc/sv-se',
    },
    translationKey: dummy_t('footer.contact'),
  },
];
